import { parseCurrencyType, type CurrencyType } from '@/lib/currency'
import { useSession } from './useSession'

/** Logged-in TM/DM/SM/M/player Lab currency. Books stay INR; convert at the edge. */
export function useViewerCurrency(): CurrencyType {
  const { data } = useSession()
  return parseCurrencyType(data?.account.currencyType)
}
